<template>
  <div class="layout">
    <div class="header">
      <div class="logo">
        <img @click="$router.push('/admin/dashboard')" style="height: 30px;marginTop: -8px"
          src="/static/images/logo.png" srcset="" />
        <img @click="$router.push('/admin/dashboard')" alt="" src="/static/images/logo-name.png" srcset="" />
        <div class="desc" v-if="$store.state.isInPC">
          <!-- <small>携手你我他</small> -->
          <p>做最温暖的陪伴者</p>
        </div>
      </div>
      <div class="info">
        <el-button :plain="true" @click="doCopy" round size="mini" type="info">获取app链接</el-button>
        <el-button round size="mini">您的角色：<span style="color:#d8388d">{{ userinfo.role_name }}</span></el-button>
      </div>
      <div class="bell" v-if="islogin">
        <el-popover placement="bottom" popper-class="popper-admin-message" trigger="click">
          <el-badge :value="unReadCount || undefined" slot="reference">
            <i class="el-icon-bell" v-trackevent="['顶部导航栏', '通知', '查看']"></i>
          </el-badge>
          <div :key="item.id" @click="setIsRead(item)" class="sys-message-item" v-for="item in systemMessages">
            <div class="icon">
              <i class="el-icon-message"></i>
            </div>
            <div class="info">
              <p>{{ item.data }}</p>
              <span>{{ formatTime(item.time) }}</span>
            </div>
            <span class="read is_read" v-if="item.is_read">已读</span>
            <span class="read un_read" v-else>未读</span>
          </div>
          <div style="font-size:12px;color:gray;text-align:center;padding:20px 0;" v-if="systemMessages.length === 0">
            暂无更多通知
          </div>
        </el-popover>
      </div>
      <div class="userInfoBox">
        <el-popover placement="bottom" popper-class="popper-admin-user" trigger="click" v-if="$store.state.isInPC">
          <div class="info" slot="reference" style="cursor:pointer;">
            <!-- <img v-if="islogin" :src="userinfo.avatar" alt="头像" />
            <i v-else class="el-icon-picture-outline"></i> -->
            <span>{{ userinfo.name }}</span>
          </div>
          <div class="more">
            <router-link class="item" to="/admin/dashboard">
              <i class="el-icon-odometer"></i>
              <span v-trackevent="['顶部导航栏', '控制台', '跳转']">控 制 台</span>
            </router-link>
            <router-link class="item" to="/admin/safe">
              <i class="el-icon-user"></i>
              <span v-trackevent="['顶部导航栏', '安全设置', '跳转']">个人信息</span>
            </router-link>
            <div @click="handback" class="item">
              <i class="el-icon-switch-button"></i>
              <span>退出登录</span>
            </div>
          </div>
        </el-popover>
        <div @click="minMenuVisible = !minMenuVisible" class="info" v-if="$store.state.isInMobile">
          <img :src="userinfo.avatar" alt="头像" v-if="islogin" v-trackevent="['顶部导航栏', '迷你菜单', '伸缩']" />
          <i class="el-icon-picture-outline" v-else></i>
        </div>
      </div>
    </div>
    <div :class="{ fold: menuFoldState }" :hidden="$store.state.isTeaching || $store.state.isInMobile"
      :style="{ backgroundColor: asideBackgroundColor }" class="aside">
      <el-scrollbar class="scrollbar">
        <el-menu :background-color="asideBackgroundColor" :collapse="menuFoldState" :collapse-transition="false"
          :default-active="$route.path" :width="menuFoldState ? '60px' : '150px'" router>
          <el-submenu :index="index.toString()" :key="index" v-for="(item, index) in menus">
            <template slot="title">
              <i :class="item.icon" class="menu-icon"></i>
              <el-badge
                :value="records.length > 0 && item.group === '问卷管理' && userinfo.rid !== 'admin' && userinfo.rid !== 'commonweal' ? records.length : undefined"
                slot="reference">
                <span>{{ item.group }}</span>
              </el-badge>
            </template>
            <el-menu-item :index="child.path" :key="child.path" v-for="child in item.children">
              <span slot="title"><i :class="child.icon" class="menu-icon"></i> <span>{{ child.title }}</span></span>
            </el-menu-item>
          </el-submenu>
        </el-menu>
      </el-scrollbar>
      <div @click="hadnleFoldBtnClick" class="fold-btn">
        <i :class="menuFoldState ? 'el-icon-d-arrow-right' : 'el-icon-d-arrow-left'"
          v-trackevent="['侧边导航栏', '迷你菜单', '伸缩']"></i>
      </div>
    </div>
    <div class="mini-aside" v-if="$store.state.isInMobile && minMenuVisible">
      <el-collapse accordion>
        <el-collapse-item :key="index" v-for="(item, index) in menus">
          <span :class="{ active: isSelectedMenu(item) }" slot="title"><i :class="item.icon"></i>
            <span>{{ item.group }}</span></span>
          <div :class="{ active: isSelectedMenu(child.path) }" :key="child.path" @click="goMenus(child)"
            style="padding-left:15px;margin:10px 0;" v-for="child in item.children">
            <i :class="child.icon"></i> <span>{{ child.title }}</span>
          </div>
        </el-collapse-item>
      </el-collapse>
      <div class="others">
        <router-link to="/login">
          <i class="el-icon-switch-button"></i>
          <span>退出登录</span>
        </router-link>
        ``
      </div>
    </div>
    <div :style="{ marginLeft: mainMarginLeft }" class="main" ref="layout-scrollbar">
      <div class="pure-main">
        <router-view></router-view>
      </div>
    </div>
    <el-backtop :right="16" v-trackevent="['主页面', '点击', '回到顶部']" />


    <div class="box">

      <el-dialog :before-close="handleClose" :title="'知情同意书'" :visible.sync="visible2" height="112%"
        style="height:90% !important;" v-if="path == '/admin/dashboard'" width="45%">
        <div style="height:438px;">
          <iframe :src="consentInfo.consentUrl" align="middle" frameborder="0" height="100%" width="100%"></iframe>
        </div>
        <div style="border: 2px solid #E6E6E6 ;background-color: white;width: 500px;height:150px;margin: 10px">

          <plugin-vue-esign :bgColor.sync="bgColor" :height="200" :isCrop="isCrop" :lineColor="lineColor"
            :lineWidth="lineWidth" :width="500" ref="esign" />
        </div>
        <el-button @click="$refs.esign.reset();" size="small" type="primary">重写签名</el-button>

        <p style="text-align: end;font-size: 16px;font-weight: bold;margin-top: 6px">山东大学信息学院“守·望行动”项目组</p>
        <p style="text-align: end;font-size: 16px;font-weight: bold;margin-top: 6px">{{ consentInfo.createTime }}</p>
        <span slot="footer">
          <el-button @click="submitParent()" size="small" type="primary">确 定</el-button>
        </span>
      </el-dialog>
    </div>
    <div>
      <el-dialog :before-close="handleClose1" :title="'课后总结'" :visible.sync="isVisible" width="1040px">
        <el-form :model="form" inline>
          <table align="center" border="1" class="table" height="580" width="100%">
            <tr colspan="6">
              <th align="center" colspan="6">志愿者 网络授课课后总结</th>
            </tr>
            <tr class="tr">
              <th align="center" class="th">志愿者姓名</th>
              <td class="td" colspan="2">
                <el-form-item>
                  <el-input :disabled="disabled" clearable placeholder="请输入志愿者姓名" style="width:300px;"
                    v-model="form.volunteerName"></el-input>
                </el-form-item>
              </td>
              <th>儿童姓名</th>
              <td colspan="2">
                <el-form-item>
                  <el-input :disabled="disabled" clearable placeholder="请输入儿童姓名" v-model="form.studentName"></el-input>
                </el-form-item>
              </td>
            </tr>
            <tr>
              <th width="12%">授课时间</th>
              <td width="14%">
                <el-date-picker :disabled="disabled" format="yyyy-MM-dd HH:mm:ss" placeholder="选择日期时间"
                  style="width:200px" type="datetime" v-model="form.startTime" value-format="yyyy-MM-dd HH:mm:ss">
                </el-date-picker>
              </td>
              <th width="14%">授课时长(分钟)</th>
              <td width="16%">
                <el-input :disabled="disabled" placeholder="授课时长" v-model="form.classTime"></el-input>
              </td>
              <th width="10%">授课科目</th>
              <td width="16%">
                <el-form-item>
                  <el-input :disabled="disabled" clearable placeholder="请输入授课科目" v-model="form.subject"></el-input>
                </el-form-item>
              </td>
            </tr>
            <tr>
              <th>课程主题</th>
              <td colspan="6">
                <el-form-item>
                  <el-input :disabled="disabled" :rows="2" clearable placeholder="请输入课程主题" style="width:760px"
                    type="textarea" v-model="form.topic"></el-input>
                </el-form-item>
              </td>
            </tr>
            <tr>
              <th>教学类型（可多选）</th>

              <td colspan="6">
                <el-form-item>
                  <el-checkbox-group v-model="form.type">
                    <el-checkbox :disabled="disabled" :key="index" :label="item.label" @change="handType"
                      v-for="(item, index) in typeList">{{ item.label }}
                    </el-checkbox>
                  </el-checkbox-group>
                  <el-input :disabled="disabled" :rows="2" clearable placeholder="请输入课程内容" style="width:760px"
                    type="textarea" v-if="type1 == true" v-model="form.typeDesc"></el-input>
                </el-form-item>

              </td>
            </tr>
            <tr>
              <th>课程内容（过程）</th>
              <td colspan="6">
                <el-form-item>
                  <el-checkbox-group v-model="form.summaryConsistentFlag">
                    <el-checkbox :disabled="disabled" :key="index" :label="item.label" @change="handConsistent"
                      v-for="(item, index) in consistentList">{{ item.label }}
                    </el-checkbox>
                  </el-checkbox-group>
                  <el-input :disabled="disabled" :rows="2" clearable placeholder="请输入课程内容" style="width:760px"
                    type="textarea" v-if="type2 == true" v-model="form.summaryContent"></el-input>
                </el-form-item>
              </td>
            </tr>
            <tr>
              <th rowspan="3">授课总结</th>
              <td>儿童课堂表现</td>
              <td colspan="6">
                <el-form-item>
                  <el-input :disabled="disabled" clearable placeholder="请输入儿童课堂表现" rows="2" style="width:460px"
                    type="textarea" v-model="form.summaryStudentPerformance"></el-input>
                </el-form-item>
              </td>
            </tr>
            <tr>
              <td>自我授课评价</td>
              <td colspan="6">
                <el-form-item>
                  <el-input :disabled="disabled" clearable placeholder="请输入自我授课评价" rows="2" style="width:460px"
                    type="textarea" v-model="form.summarySelfPerformance"></el-input>
                </el-form-item>
              </td>
            </tr>
            <tr>
              <td>系统使用情况</td>
              <td colspan="6">
                <el-form-item>
                  <el-input :disabled="disabled" clearable placeholder="请输入系统使用情况" rows="2" style="width:460px"
                    type="textarea" v-model="form.summarySystemPerformance"></el-input>
                </el-form-item>
              </td>
            </tr>
            <tr>
              <th>其他</th>
              <td colspan="6">
                <el-form-item>
                  <el-input :disabled="disabled" :rows="2" clearable placeholder="请输入课程主题" style="width:760px"
                    type="textarea" v-model="form.others"></el-input>
                </el-form-item>
              </td>

            </tr>
          </table>
        </el-form>
        <span slot="footer">
          <el-button @click="handleClose1" size="small">取 消</el-button>
          <el-button @click="handSubmit()" size="small" type="primary">确 定</el-button>
        </span>
      </el-dialog>
    </div>


  </div>


</template>

<script>
export default {
  data() {
    return {
      minMenuVisible: false,
      alreadyIds: [],
      menuFoldState: false,
      appUrl: '',
      visible2: false,
      visibleParent: false,
      visible: false,
      consentInfo: {},
      records: [],

      beforeTotal: 0,
      runTotal: 0,
      afterTotal: 0,
      year: new Date(),
      month: new Date(),
      ispbl: '',
      activity: '',
      // 电子签名
      lineWidth: 2,
      lineColor: '#000000',
      bgColor: '',
      resultImg: '',
      isCrop: false,
      notifyList: [],
      type1: false,
      type2: false,
      disabled: false,
      path: '',
      beginOfWeekDay: [],
      form: {
        volunteerName: '',
        startTime: '',
        type: [],
        id: '',
        summaryContent: '',
        planContent: '',
        summaryConsistentFlag: [],
        studentName: '',
      },

      typeList: [
        { label: '课本知识-预习' },
        { label: '课本知识-复习' },
        { label: '作业辅导' },
        { label: '课外知识' },
        { label: '其他' },
      ],
      consistentList: [
        { label: '与《志愿者网络授课教案》填写的课程内容（过程）一致' },
        { label: '与《志愿者网络授课教案》填写的课程内容（过程）不一致' },
      ],
    }
  },
  computed: {
    isVisible() {
      return this.$store.state.isVisible
    },
    islogin() {
      return this.$store.state.isLogin
    },
    userinfo() {
      return this.$store.state.userinfo
    },
    adminPages() {
      return this.$store.state.fileConfigs.filter(o => o.parent === '/admin');
    },
    adminPermits() {
      return this.$store.state.permitList.filter(o => o.type === '0').map(o => o.path);
    },
    menus() {
      const list = [];
      this.adminPages.filter(o => this.adminPermits.includes(o.path)).sort((a, b) => a.sort - b.sort).forEach(item => {
        if (list.filter(o => item.group === o.group).length === 0) {
          if (item.group) {
            list.push({ group: item.group, icon: item.icon, children: [] });
          }
        }
        const index = list.findIndex(o => o.group === item.group);
        if (index > -1) {
          list[index].children.push(item);
        }
      });
      if (list.length === 0) {
        this.$router.push('/login')
        return
      }
      return list;
    },
    routePath() {
      let path;
      try {
        path = this.$route.matched[1].path;
      } catch (err) {
        path = this.$route.path;
      }
      return path;
    },
    activePageName() {
      return (this.adminPages.find(o => o.path === this.routePath) || {}).title;
    },
    dbKey() {
      return `chat_records_${this.userinfo.id}`;
    },
    systemMessages() {
      const list = (this.$store.state.chatRecords || []).filter(o => o.from.toLowerCase() === '525141').sort((a, b) => Number.parseInt(a.time, 10) - Number.parseInt(b.time, 10));
      return list.map(o => {
        o.is_read = this.alreadyIds.includes(o.id);
        return o;
      });
    },
    unReadCount() {
      return this.systemMessages.filter(o => !o.is_read).length;
    },
    mainMarginLeft() {
      if (this.$store.state.isInMobile || this.$store.state.isTeaching) {
        return '0';
      } else if (this.menuFoldState) {
        return '60px';
      } else {
        return '150px';
      }
    },
    asideBackgroundColor() {
      return '#d3dce6';
    }
  },
  mounted() {
    this.$forceUpdate(this.menus)
    this.path = this.$route.path
    this.beginOfWeek()
    this.getAlreadyIds();
    this.getaspx();
    this.getAnswer()
    this.getCheck();
    if (localStorage.getItem('visible2')) {
      this.getActivityConsent()
    }
    this.$LocalForage.getItem('SYS_MENUBAR_KEY').then(value => {
      this.menuFoldState = value;
    });
  },
  methods: {
    handback() {
      sessionStorage.setItem('visible2', true);
      this.$router.push('/login')
      require('../../javaAuth').logout();
    },
    getActivityConsent() {
      this.$jHttp.post(`/activity/page?pageNum=1&pageSize=15`, {
        activityName: "",
        activityType: ""
      }).then(res => {
        if (!res.data.rows || res.data.rows.length == 0 || res.data.rows[0].id == '' || res.data.rows[0].id == null) {
          this.visible2 = false
        } else {
          let id = res.data.rows[0].id
          this.$jHttp.post(`/activity_consent/page?pageNum=1&pageSize=10`, {
            currentUserId: this.userinfo.id, // 当前登录用户ID
            currentRid: this.userinfo.rid,    // 当前登录用户角色
            name: this.userinfo.name,        // 签署人名称
            rid: this.userinfo.rid,
            activityId: id
          }).then(res => {
            if (res.data.rows.length == 0) {
              this.visible2 = false
            } else if (res.data.rows[0].agreeFlag == '1') {
              this.visible2 = false
            } else {
              this.visible2 = true
              this.consentInfo = res.data.rows[0]
              this.consentInfo.createTime = this.formatDate(this.consentInfo.createTime)
            }
          })
        }
      })
    },
    submitParent() {
      // 电子签名
      // 生成base64格式
      this.$refs.esign.generate().then(res => {
        // this.resultImg = res //把base64赋给img
        // let fd = this.base64toFile(res);
        // let fd2 = JSON.stringify(fd)
        // this.$api.fileUpload({ files: {file : fd2} }).then(x => {
        // })
        let $Blob = this.getBlobBydataURI(res, 'image/png');
        let formData = new FormData();
        formData.append("file", $Blob, "file_" + Date.parse(new Date()) + ".png");
        this.$api.fileUpload(formData).then(x => {
          let data = x.data.data
          let consentInfo = this.consentInfo
          this.$jHttp.put(`/activity_consent/signing/${consentInfo.id}/1?signUrl=${data.url}`).then(res => {

            if (res.data.code === 200) {
              this.$message({
                message: '提交成功',
                type: 'success'
              })
              this.visible2 = false
              this.getCheck();
            }
          })
          // this.$api.parentagree({id:this.$store.state.userinfo.id}).then(res => {
          //   this.visibleParent = false;
          //   // this.getCheck();
          //   this.$notify({
          //     title: '提交成功',
          //     type: 'success'
          //   });
          // })
        })
      }).catch(err => {
        // 画布没有签字时会执行这里
        this.$notify({
          title: '请填写签名',
          type: 'error'
        });
      })

    },
    getCheck() {
      this.$api.check({ rid: this.$store.state.userinfo.rid }).then(({ data: res }) => {
        this.ispbl = res.data.ispbl;
        this.activity = res.data.activity;
        // 是否活动中
        if (!res.data.activity) return;
        // 是否是家长
        // && this.$store.state.userinfo.rid === 'parent'
        if (this.$store.state.userinfo.rid == 'parent') {
          this.visibleParent = true;
          return;
        }
        if (!res.data.enableAppointmentClasses && this.$store.state.userinfo.rid !== 'parent') {
          this.$message({
            message: '请通知儿童家长填写同意书，否则您将无法上课',
            type: 'error'
          });
        } else {
          if (!res.data.accention && this.$store.state.userinfo.rid !== 'parent') {
            this.visible = true;
          } else {
            this.visible = false;
          }
        }
      })
    },
    submit() {
      this.$api.attention({ id: this.$store.state.userinfo.id, ispbl: this.ispbl }).then(({ data: res }) => {
        this.getCheck();
      })
    },
    getBlobBydataURI(dataURI, type) {
      var binary = atob(dataURI.split(',')[1]);
      var array = [];
      for (var i = 0; i < binary.length; i++) {
        array.push(binary.charCodeAt(i));
      }
      return new Blob([new Uint8Array(array)], { type: type });
    },
    isSelectedMenu(menu) {
      if (typeof menu === 'string') {
        return menu === this.$route.path;
      } else {
        return menu.children.map(o => o.path).includes(this.$route.path);
      }
    },
    goMenus(child) {
      this.$router.push(child.path);
      this.minMenuVisible = false;
    },
    easemobInit() {
      this.$nextTick(() => {
        if (!this.$onIMReady) return false;
        this.$onIMReady.then(() => {
          try {
            this.$LocalForage.getItem(this.dbKey).then(records => {
              this.$store.commit('updateChatRecords', records || []); // 填充历史聊天记录
            }).finally(() => {
              this.$WebIM.conn.listen({
                onOpened: this.handleEasemobOpen,
                onClosed: this.handleEasemobClose,
                onTextMessage: this.handleEasemobText,
                onPictureMessage: this.handleEasemobImage,
                onFileMessage: this.handleEasemobFile,
                onLocationMessage: this.handleEasemobLocation,
                onAudioMessage: this.handleEasemobAudio,
                onEmojiMessage: this.handleEasemobEmoji,
                onCmdMessage: this.handleEasemobCmd,
                onVideoMessage: this.handleEasemobVideo,
                onError: this.handleEasemobError,
              });

              this.$WebIM.conn.open({
                apiUrl: this.$WebIM.config.apiURL,
                user: this.userinfo.id,
                pwd: this.userinfo.id,
                appKey: this.$WebIM.config.appKey
              });
            });
          } catch (error) {
          }
        });
      });
    },
    handleEasemobOpen() {
      // console.log('easemob 连接成功');
    },
    handleEasemobClose() {
      // console.log('easemob 连接关闭');
    },
    handleEasemobText(data) {
      data.from = data.from.toLowerCase(); // FUCK IM 环信给回的id和本地的id不小写不一样
      data.ext = data.ext || {}; // 默认需要有拓展信息
      data.ext.nickname = data.ext.nickname || data.ext.userName; // 兼容app发来的用户昵称
      data.ext.avatar = data.ext.avatar || data.ext.userPic; // 兼容app发来的用户头像
      data.ext.type = data.ext.type || 'txt'; // 兼容app发来的信息类型
      const records = this.$store.state.chatRecords.concat([data]);
      this.$store.commit('updateChatRecords', records); // 状态管理器
      this.$LocalForage.setItem(this.dbKey, records); // 缓存聊天记录
    },
    handleEasemobImage(data) {
      data.ext.file_json = JSON.parse(JSON.stringify(data.ext.file_json));
      data.data = data.ext.file_json.url;
      data.ext.type = 'img';
      this.handleEasemobText(data);
    },
    //问卷
    getAnswer() {
      this.$jHttp.post(`/questionnaire/detail/page`, {
        userId: this.userinfo.id == '525141' ? '' : this.userinfo.id
      }).then(res => {
        if (res.data.rows.length > 0 && res.data.rows[0].answerFlag == '0') {
          const h = this.$createElement;
          const notify = this.$notify({
            title: '提示',
            message: h(
              "p",
              {
                style: "width: 250px;display: flex;justify-content: space-between;",
              },
              [
                h("span", null, '您有问卷需要作答'),
                h(
                  "a",
                  {
                    style: "color: #409EFF;cursor: pointer;",
                    on: {
                      click: this.closeNotify,
                    },
                  },
                  "去作答"
                ),
              ]
            ),
            position: "top-right",
            type: "warning",
            duration: 10000,
            customClass: "custom-class",
          });

        }
      })

    },
    closeNotify() {
      this.$router.push('/admin/questlist')
      this.$notify.closeAll()
    },

    handleEasemobFile(data) {
      data.ext.file_json = JSON.parse(JSON.stringify(data.ext.file_json));
      data.data = data.ext.file_json.url;
      data.ext.type = 'file';
      this.handleEasemobText(data);
    },
    handleEasemobLocation(data) {
      data.data = data.addr;
      data.ext.type = 'location';
      this.handleEasemobText(data);
    },
    handleEasemobAudio(data) {
      data.ext.type = 'audio';
      this.handleEasemobText(data);
    },
    onEmojiMessage(data) {
      data.ext.type = 'emoji';
      this.handleEasemobText(data);
    },
    onCmdMessage(data) {
      data.ext.type = 'cmd';
      this.handleEasemobText(data);
    },
    onVideoMessage(data) {
      data.ext.type = 'video';
      this.handleEasemobText(data);
    },
    handleEasemobError(error) {
      // console.log('easemob 异常', error);
    },
    getAlreadyIds() {
      this.$LocalForage.getItem('already_ids').then(ids => {
        this.alreadyIds = ids || [];
      })
    },
    formatTime(datestr) {
      const date = new Date(Number.parseInt(datestr, 10));
      const yyyy = date.getFullYear();
      const MM = date.getMonth() + 1;
      const dd = date.getDate();
      const hh = date.getHours();
      const mm = date.getMinutes();
      const ss = date.getSeconds();
      return `${yyyy}-${MM}-${dd} ${hh}:${mm}:${ss}`
    },
    setIsRead(item) {
      if (!item.is_read) {
        this.alreadyIds = Array.from(new Set([item.id].concat(this.alreadyIds)));
        this.$LocalForage.setItem('already_ids', this.alreadyIds); // 缓存已读记录
      }
    },
    handleClose() {
      this.$confirm('是否退出知情同意书同意操作？如若退出，下次登录还需填写知情同意书', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.visible2 = false;
        localStorage.removeItem("visible2")
        this.visible = false;
        this.visibleParent = false;
      }).catch(() => {
        // TODO
      })
    },
    // 监听侧边栏折叠事件
    hadnleFoldBtnClick() {
      this.menuFoldState = !this.menuFoldState;
      this.$LocalForage.setItem('SYS_MENUBAR_KEY', this.menuFoldState);
    },
    doCopy() {
      this.$api.versionList().then(({ data: res }) => {
        this.appUrl = res.data.list[0].url
        this.$copyText(this.appUrl).then(e => {
          this.$message({
            message: '复制链接至粘贴板',
            type: 'success'
          });
        }, e => {
          this.$message({
            message: '复制链接失败',
            type: 'error'
          });
        })
      })
    },
    formatDate(oldDate) {
      // 方式1 转换为'yyyy-MM-dd HH:mm:ss'
      function add0(num) {
        return num < 10 ? '0' + num : num
      } // 个位数的值在前面补0
      const date = new Date(oldDate)
      const Y = date.getFullYear()
      const M = date.getMonth() + 1
      const D = date.getDate()
      const h = date.getHours()
      const m = date.getMinutes()
      const s = date.getSeconds()
      const dateString = Y + '-' + add0(M) + '-' + add0(D) + '  ' + add0(h) + ':' + add0(m) + ':' + add0(s)
      return dateString
      // 方式2 转换为'yyyy/MM/dd HH:mm:ss'
      // return new Date(oldDate).toLocaleString()
    },
    getaspx() {
      this.$api.userCenter().then(re => {
        // if(!['admin','commonweal'].includes(re.data.data.rid)) this.pagination.id = re.data.data.id;
        this.$api.questionnaireList({ id: !['admin', 'commonweal'].includes(re.data.data.rid) ? re.data.data.id : '' }).then(({ data: res }) => {

          this.records = res.data.list.map(e => {
            e.doobeject = e.doobeject.split(',')
            return e
          }) || [];
          const flag = this.records.every(e => new Date(e.endtime) > new Date());
          // re.data.data.rid !== 'admin' && re.data.data.rid !== 'commonweal'
          if (this.records.length > 0 && !['admin', 'commonweal', '', null, undefined].includes(re.data.data.rid) && flag) {
            this.$notify({
              title: '您有调查问卷需要作答',
              // message: '您有一份调差问卷',
              type: 'warning'
            });
          }
        })
      })
    },

    //课后总结
    async handleClose1() {
      this.$confirm('是否退出课后总结填报？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        let beginOfWeekDay = this.beginOfWeekDay
        this.$jHttp.post(`/teach_plan_summary/page?pageNum=1&pageSize=10`, {
          category: "2",  // 类型   1课程教案  2课后总结
          submitFla: "1", // 是否提交  0未提交 1已提交
          createTimeStart: beginOfWeekDay ? beginOfWeekDay[0] + ' 00:00:00' : '', // 下发开始时间
          createTimeEnd: beginOfWeekDay ? beginOfWeekDay[6] + ' 23:59:59' : '', // 下发结束时间
          id: "",
          volunteerId: this.userinfo.id == '525141' ? '' : this.userinfo.id
        }).then(res => {
          let data = res.data.rows
          if (data.length < 1) {
            this.$jHttp.put(`/teach_plan_summary`, {
              category: '2',
              submitFlag: "1",
              volunteerId: this.userinfo.id ? this.userinfo.id : '',
              volunteerName: this.userinfo.name,
              studentId: this.userinfo.studentId ? this.userinfo.studentId : '',
              startTime: '',
              classTime: '',
              topic: '',
              subject: '',
              objective: '',
              type: '',
              typeDesc: '',
              summaryConsistentFlag: '',
              summaryContent: '',
              summaryStudentPerformance: '',
              summarySelfPerformance: '',
              summarySystemPerformance: '',
              others: ''
            }).then(res => {
              // if(res.data.code===200){
              //     this.$message({
              //         message:'填报成功',
              //         type:'success'
              //     })
              this.$store.commit('updateVisible', false)
              // }
            })
          } else {
            this.$store.commit('updateVisible', false)
          }

        })

      }).catch(() => {
        // TODO
      })
    },
    handSubmit() {
      let beginOfWeekDay = this.beginOfWeekDay
      this.$jHttp.post(`/teach_plan_summary/page?pageNum=1&pageSize=10`, {
        category: "2",  // 类型   1课程教案  2课后总结
        submitFla: "", // 是否提交  0未提交 1已提交
        createTimeStart: beginOfWeekDay ? beginOfWeekDay[0] + ' 00:00:00' : '', // 下发开始时间
        createTimeEnd: beginOfWeekDay ? beginOfWeekDay[6] + ' 23:59:59' : '', // 下发结束时间
        id: "",
        volunteerId: this.userinfo.id == '525141' ? '' : this.userinfo.id
      }).then(res => {
        let data = res.data.rows
        if (data.length > 0) {
          let id = data[0].id
          let type = this.form.type.toString()
          let summaryConsistentFlag = this.form.summaryConsistentFlag.toString()
          this.$jHttp.put(`/teach_plan_summary/${id}`, {
            category: '2',
            submitFlag: "1",
            volunteerId: this.userinfo.id ? this.userinfo.id : '',
            volunteerName: this.userinfo.name,
            studentId: this.userinfo.studentId ? this.userinfo.studentId : '',
            studentName: this.userinfo.studentName,
            startTime: this.form.startTime,
            classTime: this.form.classTime,
            topic: this.form.topic,
            subject: this.form.subject,
            objective: this.form.objective ? this.form.objective : '',
            type: type ? type : '',
            typeDesc: this.form.typeDesc,
            planContent: this.form.planContent ? this.form.planContent : '',
            planResources: this.form.planResources ? this.form.planResources : '',
            summaryConsistentFlag: summaryConsistentFlag ? summaryConsistentFlag : '',
            summaryContent: this.form.summaryContent ? this.form.summaryContent : '',
            summaryStudentPerformance: this.form.summaryStudentPerformance ? this.form.summaryStudentPerformance : '',
            summarySelfPerformance: this.form.summarySelfPerformance ? this.form.summarySelfPerformance : '',
            summarySystemPerformance: this.form.summarySelfPerformance ? this.form.summarySelfPerformance : '',
            others: this.form.others
          }).then(res => {
            if (res.data.code === 200) {
              this.$message({
                message: '填报成功',
                type: 'success'
              })
              this.$store.commit('updateVisible', false)
            }
          })
        } else {
          let type = this.form.type.toString()
          let summaryConsistentFlag = this.form.summaryConsistentFlag.toString()
          this.$jHttp.put(`/teach_plan_summary`, {
            category: '2',
            submitFlag: "1",
            volunteerId: this.userinfo.id ? this.userinfo.id : '',
            volunteerName: this.form.volunteerName,
            studentId: this.userinfo.studentId ? this.userinfo.studentId : '',
            studentName: this.form.studentName,
            startTime: this.form.startTime,
            classTime: this.form.classTime,
            topic: this.form.topic,
            subject: this.form.subject,
            objective: this.form.objective ? this.form.objective : '',
            type: type ? type : '',
            typeDesc: this.form.typeDesc,
            summaryConsistentFlag: summaryConsistentFlag ? summaryConsistentFlag : '',
            summaryContent: this.form.summaryContent ? this.form.summaryContent : '',
            summaryStudentPerformance: this.form.summaryStudentPerformance ? this.form.summaryStudentPerformance : '',
            summarySelfPerformance: this.form.summarySelfPerformance ? this.form.summarySelfPerformance : '',
            summarySystemPerformance: this.form.summarySelfPerformance ? this.form.summarySelfPerformance : '',
            others: this.form.others
          }).then(res => {
            if (res.data.code === 200) {
              this.$message({
                message: '填报成功',
                type: 'success'
              })
              this.$store.commit('updateVisible', false)
            }
          })
        }
      })
    },
    handType(val) {
      if (this.form.type.indexOf('其他') !== -1) {
        this.type1 = true
      } else {
        this.type1 = false
      }
    },
    handConsistent(val) {
      if (this.form.summaryConsistentFlag.indexOf('与《志愿者网络授课教案》填写的课程内容（过程）不一致') !== -1) {
        this.type2 = true
      } else {
        this.type2 = false
      }
    },

    //获取每周的开始日期和结束日期
    //周开始日期（周一为每周开始，周日为每周结束）
    beginOfWeek() {
      var now = new Date();
      var nowTime = now.getTime();
      var day = now.getDay();
      var oneDayLong = 24 * 60 * 60 * 1000;
      //计算这一周
      var data = [];
      for (var i = 1; i < 8; i++) {
        var SundayTime = nowTime + (i - day) * oneDayLong;
        var SundayTime = new Date(SundayTime);
        var y = SundayTime.getFullYear();//年
        var m = SundayTime.getMonth() + 1;//月
        var d = SundayTime.getDate();//日
        var h = SundayTime.getHours();//时
        var mm = SundayTime.getMinutes();//分
        var s = SundayTime.getSeconds();//秒
        m = m < 10 ? "0" + m.toString() : m;
        d = d < 10 ? "0" + d.toString() : d;
        var val = y.toString() + "-" + m.toString() + "-" + d.toString();
        data.push(val);
      }
      return this.beginOfWeekDay = data;
    },

  },
  watch: {
    islogin: {
      handler() {
        if (this.islogin) {
          // this.easemobInit();
        }
      },
      immediate: true,
    },
    activePageName: {
      handler() {
        if (!this.$isServer) {
          document.title = `${this.activePageName ? `${this.activePageName}丨` : ''}${document.title.split('丨').pop()}`;
        }
      },
      immediate: true
    }
  }
}
</script>

<style lang="less" scoped>
.layout {
  min-height: calc(100vh - 50px);
  font-size: 16px;
  /*no*/
  position: relative;
  overflow: hidden;

  //      ::v-deep.el-dialog{
  //   // height: 90% !important;
  //   margin-top: 10px !important;
  // }
  //     ::v-deep.el-dialog__footer {
  //     padding: 0px 20px 20px
  //   }
  // ::v-deep.el-dialog__wrapper{
  //   height:112%  !important;
  //   overflow: visible;
  // }
  .header {
    position: fixed;
    top: 0;
    left: 0;
    z-index: 99;
    width: 100%;
    max-width: 100vw;
    background-color: #006edf;
    color: #fff;
    height: 50px;
    line-height: 50px;
    /*no*/
    display: flex;
    align-items: center;
    user-select: none;
    box-shadow: 0 0 6px gray;
    box-sizing: border-box;
    padding: 0 20px;

    .logo {
      flex: none;
      display: flex;
      align-items: center;
      font-size: 16px;
      /*no*/

      img {
        height: 36px;
        /*no*/
      }

      .desc {
        margin-left: 15px;
        /*no*/
        font-size: 16px;
        /*no*/
        line-height: 16px;
        /*no*/
        color: rgba(255, 255, 255, 0.4);

        p {
          padding: 0;
          margin: 0;
          color: rgba(255, 255, 255, 0.7);
        }
      }
    }

    .info {
      flex: 1;
      text-align: right;
      margin: 0 15px;

      .el-button {
        background-color: #fff;
        cursor: default;
        color: #606266;
      }
    }

    .bell {
      flex: none;
      height: 45px;

      /deep/ sup {
        top: 16px;
        /*no*/
      }

      i {
        font-size: 20px;
        /*no*/
      }
    }

    .userInfoBox {
      flex: none;
      cursor: pointer;

      .info {
        display: flex;
        align-items: center;

        span {
          padding-left: 8px;
          /*no*/
          font-size: 14px;
        }

        img {
          width: 36px;
          /*no*/
          height: 36px;
          /*no*/
          border-radius: 50%;
        }

        .el-icon-picture-outline {
          font-size: 18px;
          /*no*/
        }
      }
    }
  }

  .aside {
    width: 170px;
    height: calc(100vh - 50px);
    position: fixed;
    top: 50px;
    left: 0;
    z-index: 99;

    .el-menu {
      border-right-color: transparent;

      .menu-icon {
        font-size: 16px;
        margin-right: 5px;
      }
    }

    .fold-btn {
      display: none;
    }

    &.fold {
      width: 60px;
    }

    &:hover {
      .fold-btn {
        display: block;
        position: absolute;
        background: #272727;
        top: calc(50% - 18px);
        right: -16px;
        width: 16px;
        height: 36px;
        line-height: 36px;
        text-align: center;
        border-radius: 0 4px 4px 0;
        color: #fff;
        font-size: 14px;
        cursor: pointer;

        &:hover {
          box-shadow: 0 0 2px gray;
        }
      }
    }
  }

  .mini-aside {
    padding: 12px;
    /*no*/
    box-sizing: border-box;
    width: 100vw;
    position: fixed;
    top: 50px;
    /*no*/
    z-index: 9999;
    background: #006edf;
    color: #fff;
    border-top: 1px solid #a2a2a2;
    /*no*/
    box-shadow: 0px 20px 20px -20px #5e5e5e;
    /*no*/

    .el-collapse {
      border: none;
      border-bottom: none;

      /deep/ .el-collapse-item__header {
        background: transparent;
        color: #fff;
        border: none;
      }

      /deep/ .el-collapse-item__wrap {
        background: transparent;
        border: none;

        .el-collapse-item__content {
          color: #fff;
        }
      }

      .active {
        color: #f60;
      }
    }

    .others {
      text-align: right;
      padding: 20px 12px 5px 12px;
      /*no*/

      a {
        text-decoration: none;
        font-size: 14px;
        /*no*/
        color: red;
        line-height: 25px;
        /*no*/
      }
    }
  }

  .main {
    color: #333;
    margin-top: 50px;
    margin-left: 150px;
    min-height: calc(100vh - 50px);
    width: 92%;

    .pure-main {
      height: 94vh;
      overflow-y: scroll;
      padding: 16px 16px 16px 36px;

      &::-webkit-scrollbar {
        display: none;
      }
    }
  }

  .scrollbar {
    box-sizing: border-box;
    height: 100%;

    /deep/ .el-scrollbar__wrap {
      overflow-x: hidden;
    }
  }

  .table {
    font-size: 20px;
    border: 1px solid rgba(0, 0, 0, 0.5);

    ::v-deep.el-input__inner {
      border: none;
    }

    ::v-deep.el-textarea__inner {
      border: none;
    }

    .el-form-item {
      margin: 0 10px;
    }

    tr {
      border-right: 1px solid rgba(0, 0, 0, 0.5);
      border-bottom: 1px solid rgba(0, 0, 0, 0.5);
      text-align: center;

    }

    //文本居中
    th {
      border-right: 1px solid rgba(0, 0, 0, 0.5);

      text-align: center;

    }

    td {
      border-right: 1px solid rgba(0, 0, 0, 0.5);

    }
  }

  ::v-deep .el-pagination {
    text-align: right;
    // margin-top:10px;
  }

  ::v-deep .el-input.is-disabled .el-input__inner {
    background-color: #fff;
    border-color: #E4E7ED;
    color: #434343;
    cursor: not-allowed;
  }

  ::v-deep.el-textarea.is-disabled .el-textarea__inner {
    background-color: #fff;
    border-color: #E4E7ED;
    color: #434343;
    cursor: not-allowed;
  }

  .searchbar {
    margin: -16px -16px 16px -16px;
    padding: 16px 16px 0 16px;
    background: #fff;
    box-shadow: 0px 6px 6px -1px rgba(56, 132, 194, 0.1);
  }
}
</style>

<style lang="less">
.popper-admin-user {
  padding: 0;

  .more {
    margin: 10px 0;
    /*no*/

    .item {
      display: flex;
      justify-content: center;
      align-items: center;
      text-decoration: none;
      color: #333;
      padding: 10px 12px;
      /*no*/
      font-size: 14px;
      /*no*/

      &:hover {
        background: #006edf1a;

        i {
          color: #f60;
        }
      }

      i {
        flex: none;
        margin: 0 10px;
      }

      span {
        flex: 1;
      }
    }
  }
}

.el-drawer {
  font-size: 16px;
  /*no*/
}

.popper-admin-message {
  .sys-message-item {
    width: 260px;
    /*no*/
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 8px 0;
    /*no*/
    border-top: 1px solid #f2f2f2;
    /*no*/

    &:first-child {
      border: none;
    }

    &.is_read {
      cursor: default;
    }

    .icon {
      flex: none;
      width: 40px;
      /*no*/
      height: 40px;
      /*no*/
      border-radius: 50%;
      text-align: center;
      color: #fff;
      background: red;
      font-size: 20px;
      /*no*/
      display: flex;
      justify-content: center;
      align-items: center;
    }

    .info {
      flex: 1;
      margin: 0 15px;
      /*no*/
      font-size: 12px;
      /*no*/

      p {
        font-weight: bold;
        padding-bottom: 5px;
        /*no*/
      }
    }

    .read {
      font-size: 14px;
      color: #409eff;
      cursor: pointer;

      &.is_read {
        color: #67c23a;
        cursor: default;
      }
    }
  }
}
</style>

<style lang="less" scoped>
.box {
  ::v-deep.el-dialog {
    height: 107% !important;
    margin-top: 10px !important;
  }

  ::v-deep.el-dialog__footer {
    padding: 0px 20px 20px
  }

  ::v-deep.el-dialog__wrapper {
    height: 112% !important;
    overflow: visible;
  }
}
</style>
